import { GetProps, Typography } from 'antd';

type ParagraphProps = GetProps<typeof Paragraph>;
type TitleProps = GetProps<typeof Title>;

const { Title, Paragraph } = Typography;

const BCTypographyTitle = (props: TitleProps) => <Title {...props} />;

const BCTypographyParagraph = (props: ParagraphProps) => <Paragraph {...props} />;

export { BCTypographyParagraph, BCTypographyTitle };
